import { SortOrder } from '../../../../components/blackrock/advisor-center/select/SelectProps.ts';
import { SortTypes } from './model.ts';

export const ITEM_PER_PAGE = 6;

// default initial selected sort
export const DEFAULT_SORT = 'publishedDate' as SortTypes;

// default initial sort order
export const DEFAULT_SORT_ORDER = SortOrder.ascending;
